import { render, staticRenderFns } from "./PackerDashboard.vue?vue&type=template&id=0994e17a&"
import script from "./PackerDashboard.vue?vue&type=script&lang=js&"
export * from "./PackerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports